import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@saucelabs/ds-typography/lib';

import { ROUTE_PARENT_SECTION, ROUTE_SECTION_PURCHASE } from '../../../constants';

export const OrderSummaryHeader: React.FC = () => (
  <div className="flex flex-row justify-between mb-2">
    <Typography
      className="text-high-emphasis m-0"
      disableSpacing
      variant="heading-3"
    >
      Order Summary
    </Typography>
    <Link
      to={`/${ROUTE_PARENT_SECTION}/${ROUTE_SECTION_PURCHASE}`}
    >
      Edit
    </Link>
  </div>
);

export const OrderSummarySeparator: React.FC = () => (
  <div className="h-px bg-gray-300" />
);
